import { useEffect, useRef, useState } from "react";
import { ReactComponent as ChronometerIcon } from "../../../assets/mix_icons/chronometer.svg";
import clockAlert from '../../../assets/audios/clock_hurry.mp3';
import './Chronometer.css';

const MIN_TIME = 10;

export default function Chronometer({ time }) {
    const clockAlertRef = useRef(false);
    const [isHurry, setIsHurry] = useState(false);

    useEffect(() => {
        if (time <= MIN_TIME && !clockAlertRef.current) {
            const audio = new Audio(clockAlert);
            audio.play();
            clockAlertRef.current = true;
        } else if (time > MIN_TIME) {
            clockAlertRef.current = false;
        }
        setIsHurry(time <= MIN_TIME);
    }, [time]);

    return (
        <div className={`p brown-shadow flex flex-col justify-center items-center chronometer-container rounded-xl ${isHurry ? 'bg-red shaking-slow' : 'bg-yellow'}`}>
            <div className={`p rounded-lg h-full relative overflow-hidden flex items-center justify-center gap-1 ${isHurry ? 'bg-white' : 'bg-orange'}`}>
                <div className={`${isHurry ? 'bg-red' : 'bg-gradient-yellow-gold'} rounded-md flex items-center gap-2 p-1 relative z-2 in-game-content`}>
                    <ChronometerIcon height={18} width={18} className={`object-fit ${isHurry ? 'media-icon-white' : 'media-icon-brown'}`} />
                    <span className={`text-base ${isHurry ? 'pulse-fast' : ''}`}>{time > 0 ? time : 0}</span>
                </div>
            </div>
        </div>
    )
}